var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKamchatka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384.176,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m468.386-97.802.762 419.644c.005.246.012.504.012.752 0 16.64-13.496 30.136-30.134 30.136-.082 0-.161.297-.243.297l-127.904-.1c-16.083 0-32.851 13.22-33.638 29.27h-.012c-.788-16.05-17.882-29.27-33.964-29.27l-127.905.1c-.082 0-.16-.297-.243-.297-16.638 0-30.133-13.495-30.133-30.136 0-.248.006-.506.01-.752l.784-419.643h382.608z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.148 321.842c.005.246.012.503.012.754 0 16.639-13.496 30.134-30.134 30.134-.082 0-.161.297-.243.297l-127.904-.1c-16.083 0-32.851 13.22-33.638 29.271h-.01c-.79-16.052-17.884-29.271-33.966-29.271l-127.905.1c-.082 0-.16-.297-.243-.297-16.176 0-29.38-12.758-30.1-28.757v-13.346l.145-76.053 1.933 1.142c35.888-1.704 54.866-27.369 91.778-27.605 11.708-.076 25.803 2.999 40.474 9.103 23.655 9.842 49.448 23.582 74.057 15.799 38.667-12.23 57.233-27.815 87.249-24.044 29.713 3.734 58.2 21.982 88.186 27.465l.309 85.408z",
    style: {
      color: "#000",
      fill: "#0051ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.66666669,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.185 191.579c25.837-12.917 66.095-50.363 90.7-81.704L192.8 88.404l-3.425 15.207 11.774-19.74-6.138 24.234 19.09-17.896 1.716 26.478 13.88-27.907 13.263 19.51.089-18.184 44.612 33.533-20.992-26.308 19.281 12.797 6.97-16.58 24.77 23.407-1.468-17.023 45.893 26.491-28.043-21.208 17.182 5.87 5.008-9.574 12.273 9.366-.56-10.562 20.212 22.648c19.61 21.421 61.517 55.778 80.77 68.708v22.232c-29.986-5.483-58.423-24.146-88.138-27.881-30.015-3.773-48.58 11.814-87.246 24.043-24.611 7.783-50.402-5.955-74.057-15.798-14.672-6.104-28.767-9.178-40.475-9.103-36.913.237-55.891 25.901-91.778 27.604l-2.079-1.228v-19.96z",
    style: {
      fill: "#000",
      stroke: "#000",
      strokeWidth: 0.35496593
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.673 9.762c-1.57 1-4.557 6.23-5.565 11.537-1.54-1.482-3.081-2.964-4.621-4.448-3.184 6.868 3.73 22.951 6.3 30.613h7.807c2.57-7.662 9.484-23.745 6.3-30.613-1.54 1.484-3.082 2.966-4.621 4.448-1.01-5.308-4.03-10.536-5.6-11.537zm64.193 17.212c-1.57 1.001-4.556 6.23-5.565 11.537-1.542-1.482-3.081-2.964-4.62-4.446-3.185 6.866 3.727 22.951 6.297 30.612h7.809c2.57-7.66 9.484-23.746 6.298-30.612l-4.62 4.446c-1.008-5.307-4.028-10.536-5.599-11.537zm63.513 14.034c-1.57 1-4.557 6.228-5.565 11.537l-4.62-4.448c-3.185 6.867 3.729 22.952 6.299 30.612h7.807c2.57-7.66 9.484-23.745 6.3-30.612-1.54 1.482-3.082 2.964-4.621 4.448-1.01-5.309-4.03-10.537-5.6-11.537z",
    style: {
      color: "#000",
      fill: "#d81e05",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.66666669,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.062-40.784c74.147 0 134.321 60.193 134.321 134.32 0 13.992-2.146 27.483-6.122 40.168-16.535-14.803-33.654-38.723-45.17-52.417l7.546-20.202c1.004-2.942 1.55-6.06 1.364-9.079-.23-3.78-2.202-7.549-4.509-11.265l-4.346 3.818c-1.44-4.098-3.79-7.253-7.624-9.576-3.643 2.322-6.124 5.468-7.601 9.566l-4.409-3.955c-2.167 3.67-4.105 7.355-4.362 11.033-.564 8.086 6.163 21.834 8.794 29.04-5.276 6.756-11.054 13.384-17.475 18.593-11.529-9.289-20.114-18.693-30.443-31.323l7.361-20.885c1.004-2.941 1.55-6.06 1.364-9.08-.23-3.78-2.202-7.547-4.509-11.264l-4.346 3.817c-1.44-4.098-3.79-7.251-7.624-9.574-3.643 2.32-6.124 5.468-7.601 9.566l-4.409-3.955c-2.167 3.669-4.104 7.355-4.362 11.032-.219 3.143.262 6.395 1.35 9.424l7.534 20.95c-5.689 8.383-14.157 16.142-22.516 22.838-11.777-13.8-19.184-26.747-26.659-40.832l7.585-20.336c1.004-2.943 1.55-6.06 1.364-9.08-.23-3.78-2.202-7.547-4.509-11.264l-4.344 3.817c-1.443-4.098-3.793-7.251-7.626-9.575-3.643 2.32-6.123 5.467-7.601 9.567l-4.409-3.955c-2.166 3.669-4.105 7.354-4.363 11.032-.218 3.143.263 6.395 1.351 9.423l5.75 19.675c-4.526 6.519-19.71 27.47-35.003 47.274-13.495 17.477-26.85 32.852-31.164 37.85-4.451-13.484-6.88-26.49-6.88-40.865 0-74.128 60.194-134.321 134.302-134.321z",
    style: {
      color: "#000",
      fill: "#d81e05",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.66666669,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.039-65.156 29.714-4.734-12.775 15-16.94-10.266zm52.131-4.783 29.708 4.775-16.82 10.265-12.889-15.04zm51.606 11.961 26.68 13.909-19.199 4.43-7.481-18.34zm45.123 27.583 20.938 21.611-19.617-1.847-1.321-19.764zm34.341 40.752 12.993 27.14-18.014-7.98 5.022-19.16zm19.47 48.846 3.832 29.845-14.606-13.224 10.774-16.62zm3.214 52.131-5.65 29.554-9.764-17.115 15.414-12.44zM187.65-44.115l26.717-13.839-7.41 18.257-19.308-4.418zM148.197-8.76l20.983-21.564-1.268 19.662-19.715 1.903zm-26.149 45.677 13.158-27.06 4.964 19.07-18.122 7.99zm-10.477 50.986 4.113-29.807 10.636 16.586-14.749 13.22zm5.81 51.529-5.304-29.618 15.242 12.485-9.938 17.133z",
    style: {
      color: "#000",
      fill: "#0051ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.66666669,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.686-32.18 12.283-30.329 27.922 17.002a141.167 141.167 0 0 0-40.205 13.328zM175.35-4.7l1.979-32.925 31.972 7.222a142.723 142.723 0 0 0-33.95 25.704zm-25.986 36.78L140.957-.05l32.888-3.094a142.518 142.518 0 0 0-24.481 35.223zm-13.252 43.931L117.784 47.89l30.443-13.43a141.123 141.123 0 0 0-12.115 41.551zm1.16 44.515L110.916 99.19l25.09-22.372a143.566 143.566 0 0 0-1.104 17.774c0 8.859.819 17.523 2.37 25.933zM418.247 78l24.98 22.604-26.632 21.238a142.73 142.73 0 0 0 2.623-27.249 143.4 143.4 0 0 0-.971-16.594zM406.13 34.967l30.448 13.53-18.481 28.191a141.183 141.183 0 0 0-11.967-41.721zM380.78-2.598l32.912 3.22-8.56 32.218A142.485 142.485 0 0 0 380.78-2.598zm-36.275-27.969 31.948-7.357 2.123 33.028a142.662 142.662 0 0 0-34.071-25.671zm-43.792-15.025 27.807-17.143 12.485 30.344a141.164 141.164 0 0 0-40.292-13.201zm-44.664-.423 21.14-24.877 21.173 24.918a143.339 143.339 0 0 0-42.313-.041zM128.5 152.829l-7.803-2.91 16.678-29.19a144.406 144.406 0 0 0 5.106 18.681l-1.36 1.356a429.592 429.592 0 0 1-12.62 12.063z",
    style: {
      color: "#000",
      fill: "#d81e05",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.66666669,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    transform: "translate(-84.984 97.802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.536 120.642 16.507 29.62-8.426 3.041a635.657 635.657 0 0 1-13.835-12.182 142.804 142.804 0 0 0 5.754-20.479z",
    style: {
      color: "#000",
      fill: "#d81e05",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.66666669,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    transform: "translate(-84.984 97.802)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKamchatka);
export default __webpack_public_path__ + "static/media/kamchatka.ab887410fbd15667b3198ef82bd43c80.svg";
export { ForwardRef as ReactComponent };